<template>
  <el-dialog v-el-drag-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="价格" width="800px"
    @close="$reset('form')">
    <el-form ref="form" v-loading="contentLoading" :disabled="disabled" :rules="ruleValidate" :model="materialPrice"
      class="form" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="materialPrice.materialNO" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称">
            <el-input v-model="materialPrice.materialName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规格型号" prop="specification">
            <el-input v-model="materialPrice.specification" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人工" prop="manualPrice">
            <el-input v-model.trim="materialPrice.manualPrice" :disabled="materialPrice.manualPrice === '****'"
              readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成本价" prop="costPrice">
            <el-input v-model.trim="materialPrice.costPrice" :disabled="materialPrice.costPrice === '****'"
              placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成本价浮价" prop="costFloatingPrice">
            <el-input v-model.trim="materialPrice.costFloatingPrice"
              :disabled="materialPrice.costFloatingPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标准价" prop="standardPrice">
            <el-input v-model.trim="materialPrice.standardPrice"
              :disabled="materialPrice.standardPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标准价浮价" prop="standardFloatingPrice">
            <el-input v-model.trim="materialPrice.standardFloatingPrice"
              :disabled="materialPrice.standardFloatingPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第一梯价" prop="level1Price">
            <el-input v-model.trim="materialPrice.level1Price"
              :disabled="materialPrice.level1Price === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第一梯浮价" prop="level1FloatingPrice">
            <el-input v-model.trim="materialPrice.level1FloatingPrice"
              :disabled="materialPrice.level1FloatingPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第二梯价" prop="level2Price">
            <el-input v-model.trim="materialPrice.level2Price"
              :disabled="materialPrice.level2Price === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第二梯浮价" prop="level2FloatingPrice">
            <el-input v-model.trim="materialPrice.level2FloatingPrice"
              :disabled="materialPrice.level2FloatingPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第三梯价" prop="level3Price">
            <el-input v-model.trim="materialPrice.level3Price"
              :disabled="materialPrice.level3Price === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="第三梯浮价" prop="level3FloatingPrice">
            <el-input v-model.trim="materialPrice.level3FloatingPrice"
              :disabled="materialPrice.level3FloatingPrice === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上海出厂价" prop="base1Price">
            <el-input v-model.trim="materialPrice.base1Price"
              :disabled="materialPrice.base1Price === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="江苏出厂价" prop="base2Price">
            <el-input v-model.trim="materialPrice.base2Price"
              :disabled="materialPrice.base2Price === '****' || !priceEditAuth" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled || !priceEditAuth" :loading="submitLoading" type="primary"
        @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      priceEditAuth: this.$auth(394),
      disabled: false,
      contentLoading: false,
      dialogVisible: false,
      submitLoading: false,
      materialPrice: {
        materialNO: "",
        materialName: "",
        specification: "",
        manualPrice: "",
        standardPrice: "",
        standardFloatingPrice: "",
        costPrice: "",
        costFloatingPrice: "",
        level1Price: "",
        level1FloatingPrice: "",
        level2Price: "",
        level2FloatingPrice: "",
        level3Price: "",
        level3FloatingPrice: "",
        base1Price: "",
        base2Price: "",
      },
      ruleValidate: {
        standardPrice: { required: true, message: "请输入标准价", trigger: "blur" },
        standardFloatingPrice: { required: true, message: "请输入标准浮价", trigger: "blur" },
        costPrice: { required: true, message: "请输入成本价", trigger: "blur" },
        costFloatingPrice: { required: true, message: "请输入成本浮价", trigger: "blur" },
        level1Price: { required: true, message: "请输入第一梯价", trigger: "blur" },
        level1FloatingPrice: { required: true, message: "请输入第一梯浮价", trigger: "blur" },
        level2Price: { required: true, message: "请输入第二梯价", trigger: "blur" },
        level2FloatingPrice: { required: true, message: "请输入第二梯浮价", trigger: "blur" },
        level3Price: { required: true, message: "请输入第三梯价", trigger: "blur" },
        level3FloatingPrice: { required: true, message: "请输入第三梯浮价", trigger: "blur" },
        base1Price: { required: true, message: "请输入上海出厂价", trigger: "blur" },
        base2Price: { required: true, message: "请输入江苏出厂价", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.disabled = row.status === 50 ? true : false;
        this.getData(row.materialID);
      });
    },

    // 根据物料id查询价格信息
    getData(id) {
      this.contentLoading = true;
      this.$http
        .get("basic", `materialPrice/${id}`)
        .then((resp) => {
          if (resp.success) {
            this.materialPrice = Object.assign(this.materialPrice, resp.data);
            for (var i in this.materialPrice) {
              if (this.materialPrice[i] === null) {
                this.materialPrice[i] = "****";
              }
            }
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          for (var i in this.materialPrice) {
            if (this.materialPrice[i] !== "****") {
              params[i] = +this.materialPrice[i];
            }
          }
          this.submitLoading = true;
          this.$http
            .put("basic", "materialPrice", params)
            .then((res) => {
              this.submitLoading = false;
              if (res.success) {
                this.$emit("save-success");
                this.$message.success("价格维护成功");
              }
              this.dialogVisible = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
